<template>
  <div class="company-profile-wrapper">
    <!-- 顶部用户信息区 -->
    <div class="user-info-section">
      <div class="user-avatar" style="position: relative">
        <img
          :src="img"
          style="
            width: 45px;
            height: 45px;
            border-radius: 50%;
            margin-right: 9px;
          "
        />
        <span class="username">{{ username }}</span>
        <!-- 编辑图标打开弹窗 -->
        <span @click="openEditDialog" style="cursor: pointer">
          <i
            title="点击修改头像和昵称"
            class="el-icon-edit"
            style="
              color: #ffae00;
              font-size: 18px;
              line-height: 23px;
              cursor: pointer;
            "
          ></i>
        </span>
      </div>
      <div class="user-stats">
        <div class="stat-item">
          <span class="dot red"></span>
          <span class="label">收藏：</span>
          <span class="value">{{ favoriteCount }}</span>
        </div>
        <div class="stat-item">
          <span class="dot red"></span>
          <span class="label">关注：</span>
          <span class="value">{{ followCount }}</span>
        </div>
        <div class="stat-item">
          <span class="dot red"></span>
          <span class="label">星球码：</span>
          <span class="value">{{ enterpriseCode }}</span>
        </div>
      </div>
      <div class="user-avatar" style="margin-left: 24px">
        <img
          :src="`https://api.qrserver.com/v1/create-qr-code/?size=70x70&data=${encodeURIComponent(
            xcximg
          )}`"
          style="width: 80px; height: 80px"
        />
        <!-- 编辑图标打开弹窗 -->
        <button class="botts" @click="getxcx()">
          <span class="spann" style="font-size: 14px">下载</span>
        </button>
      </div>
    </div>
    <!-- 合并简介+联系方式+五组上传图 统一保存 -->
    <div class="form-section" style="border: 1px solid">
      <div class="form-row" style="margin-top: 13px">
        <span class="section-label">公司简介:</span>
        <el-input
          type="textarea"
          :rows="3"
          placeholder="请输入公司简介"
          v-model="companyIntro"
          class="form-input"
        />
      </div>
      <div class="form-row">
        <span class="section-label" style="min-width: 52px">电话1:</span>
        <el-input
          placeholder="请输入电话1"
          v-model="phone1"
          class="form-input"
          maxlength="11"
        />
        <span class="section-label" style="min-width: 52px">电话2:</span>
        <el-input
          placeholder="请输入电话2"
          v-model="phone2"
          class="form-input"
        />
        <span class="section-label" style="min-width: 52px">电话3:</span>
        <el-input
          placeholder="请输入电话3"
          v-model="phone3"
          class="form-input"
        />
        <span class="section-label" style="min-width: 52px">电话4:</span>
        <el-input
          placeholder="请输入电话4"
          v-model="phone4"
          class="form-input"
        />
        <span class="section-label" style="min-width: 52px">电话5:</span>
        <el-input
          placeholder="请输入电话5"
          v-model="phone5"
          class="form-input"
        />
      </div>
      <div class="form-row">
        <span class="section-label">地址:</span>
        <el-input
          placeholder="请输入地址"
          v-model="address"
          class="form-input"
        />
      </div>
      <div class="form-row" style="flex-wrap: wrap; gap: 12px">
        <span class="section-label">主营产品:</span>
        <el-button
          :class="{ actives: item.status == 1 }"
          class="custom-btn"
          style="margin: 0 0 8px"
          v-for="item in zylist"
          :key="item.id"
          @click="ztstatus(item, '主营产品')"
          >{{ item.name }}</el-button
        >
      </div>
      <div class="form-row" style="flex-wrap: wrap; gap: 12px">
        <span class="section-label">面料适用:</span>
        <el-button
          v-for="item in leilist"
          :class="{ actives: item.status == 1 }"
          class="custom-btn"
          style="margin: 0 0 8px"
          :key="item.id"
          @click="ztstatus(item, '面料')"
          >{{ item.name }}</el-button
        >
      </div>
      <!-- 新增五组上传区域 横向一排自动换行 -->
      <div class="upload-wrap">
        <!-- 封面 4:3 -->
        <div class="upload-item">
          <h4 class="upload-title">
            封面(比例4:3 小于300k) <span class="tip"></span>
          </h4>
          <MyUpload
            :file-list="coverList"
            show-update
            show-delete
            file-type="image"
            :size="140"
            :image-size="8192"
            :limit="1"
            @on-change="(list) => handleUploadChange(list, 'cover')"
            @on-remove="(idx) => handleUploadRemove(idx, 'cover')"
          >
            <template #icon><i class="el-icon-plus"></i></template>
            <template #title
              ><span style="font-size: 20px">封面</span></template
            >
          </MyUpload>
        </div>
        <!-- 视频 16:9 -->
        <div class="upload-item">
          <h4 class="upload-title">
            视频(比例16:9 小于20M) <span class="tip"></span>
          </h4>
          <MyUpload
            :file-list="videoList"
            show-update
            show-delete
            file-type="video"
            :size="140"
            :video-size="20480"
            :limit="1"
            @on-change="(list) => handleUploadChange(list, 'video')"
            @on-remove="(idx) => handleUploadRemove(idx, 'video')"
          >
            <template #icon><i class="el-icon-plus"></i></template>
            <template #title
              ><span style="font-size: 20px">视频</span></template
            >
          </MyUpload>
        </div>
        <!-- 背景图 9:16 -->
        <div class="upload-item">
          <h4 class="upload-title">
            背景图(比例9:16 小于20M) <span class="tip"></span>
          </h4>
          <MyUpload
            :file-list="bgImgList"
            show-update
            show-delete
            file-type="image"
            :size="140"
            :image-size="20000"
            :limit="1"
            @on-change="(list) => handleUploadChange(list, 'backgroundImg')"
            @on-remove="(idx) => handleUploadRemove(idx, 'backgroundImg')"
          >
            <template #icon><i class="el-icon-plus"></i></template>
            <template #title
              ><span style="font-size: 20px">背景图</span></template
            >
          </MyUpload>
        </div>
        <!-- 商家Logo 1:1 -->
        <div class="upload-item">
          <h4 class="upload-title">
            商家Logo(比例1:1 小于300k) <span class="tip"></span>
          </h4>
          <MyUpload
            :file-list="logoList"
            show-update
            show-delete
            file-type="image"
            :size="140"
            :image-size="20000"
            :limit="1"
            @on-change="(list) => handleUploadChange(list, 'logoImg')"
            @on-remove="(idx) => handleUploadRemove(idx, 'logoImg')"
          >
            <template #icon><i class="el-icon-plus"></i></template>
            <template #title
              ><span style="font-size: 20px">商家LoGo</span></template
            >
          </MyUpload>
        </div>
        <!-- 微信二维码 4:3 -->
        <div class="upload-item">
          <h4 class="upload-title">
            微信二维码(比例1:1 小于20M) <span class="tip"></span>
          </h4>
          <MyUpload
            :file-list="wxList"
            show-update
            show-delete
            file-type="image"
            :size="140"
            :image-size="20000"
            :limit="1"
            @on-change="(list) => handleUploadChange(list, 'weixinImg')"
            @on-remove="(idx) => handleUploadRemove(idx, 'weixinImg')"
          >
            <template #icon><i class="el-icon-plus"></i></template>
            <template #title
              ><span style="font-size: 20px">微信二维码</span></template
            >
          </MyUpload>
        </div>
      </div>
      <!-- 唯一保存按钮 -->
      <button class="bott" @click="saveAll">
        <span class="spann">保存</span>
      </button>
    </div>
    <!-- 产品列表 -->
    <div class="product-section" v-if="productList.length > 0">
      <span class="section-label">产品列表</span>
      <div class="product-container">
        <div class="product-list">
          <div
            v-for="(product, index) in productList"
            :key="index"
            class="product-item"
            @click="deti(product.id)"
          >
            <div class="product-img-wrapper">
              <img
                :src="product.coverUrl"
                alt="产品图片"
                class="product-img"
                @error="handleProductImgError"
              />
            </div>
            <el-tooltip
              effect="dark"
              :content="product.name"
              placement="top"
              popper-append-to-body
            >
              <div class="product-desc">
                <p class="pd-name">品名：{{ product.name }}</p>
                <p class="pd-spec">
                  <span style="margin-right: 23px"
                    >幅宽：{{ product.width }}</span
                  >
                  克重：{{ product.weight }}
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
    <div class="product-section" v-else>暂无产品列表</div>
    <el-dialog title="修改头像和昵称" v-model="editDialogVisible" width="400px">
      <!-- 头像区域 -->
      <div class="avatar-box">
        <img
          class="click-avatar"
          :src="tempAvatar"
          @click="fileInput.click()"
          style="
            width: 45px;
            height: 45px;
            border-radius: 50%;
            margin-right: 9px;
          "
        />
        <el-button
          size="small"
          @click="fileInput.click()"
          style="margin-left: 20px"
          >更换头像</el-button
        >
        <input
          ref="fileInput"
          type="file"
          accept="image/*"
          hidden
          @change="handleAvatarChange"
        />
      </div>
      <!-- 昵称输入 -->
      <el-form label-width="80px" style="margin-top: 24px">
        <el-form-item label="用户昵称">
          <el-input v-model="tempUsername" placeholder="请输入昵称" />
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer-btn">
          <el-button @click="editDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitUserInfo" class="custom-btn">
            确定保存
          </el-button>
        </div>
      </template>
    </el-dialog>

    <!-- 个人主页详情弹窗 -->
    <el-dialog
      v-model="dialogVisible"
      width="70%"
      top="5vh"
      :before-close="closeDialog"
      class="product-detail-dialog"
    >
      <div class="dialog-container" v-if="Object.keys(detailData).length">
        <!-- 左侧图片区域-->
        <div class="dialog-left">
          <div class="img-wrap">
            <el-carousel
              v-if="sklist.length > 0"
              height="100%"
              indicator-position="outside"
              :initial-index="indexs"
            >
              <el-carousel-item v-for="(img, index) in sklist" :key="img.url">
                <el-image
                  :src="getFullImgUrl(img.url)"
                  fit="contain"
                  style="
                    width: 100%;
                    height: 100%;
                    display: block;
                    cursor: zoom-in;
                  "
                  @click="openImgViewer(index)"
                ></el-image>
              </el-carousel-item>
            </el-carousel>
            <div v-else class="empty-img">暂无产品图</div>
          </div>
        </div>
        <!-- 右侧信息区域 完全不变 -->
        <div class="dialog-right">
          <div class="author-header">
            <div class="avatar">
              <el-image
                :src="getFullImgUrl(detailData.belongAvatarUrl)"
                fit="cover"
                circle
                style="width: 48px; height: 48px"
              ></el-image>
            </div>
            <span class="author-name">{{ detailData.belongName }}</span>
            <el-button
              :disabled="detailData.source == 1"
              @click="
                aa(
                  detailData.belongId,
                  detailData.memberFollowStatus,
                  detailData.id
                )
              "
              class="follow-btn"
              type="danger"
              >{{
                detailData.memberFollowStatus == 0 ? "关注" : "已关注"
              }}</el-button
            >
          </div>
          <!-- 产品信息 -->
          <div class="info-block">
            <h6 class="block-title">面料信息：</h6>
            <div class="info-row" style="display: flex">
              <p class="label">品名/编号:</p>
              <p class="val" style="margin-right: 35px">
                {{ detailData.name }}
              </p>
              <p class="label">幅宽:</p>
              <p class="val" style="margin-right: 35px">
                {{ detailData.width }}
              </p>
              <p class="label">克量:</p>
              <p class="val">{{ detailData.weight }}</p>
            </div>
            <div class="info-row">
              <span
                class="label"
                style="width: 32px !important; display: inline-block"
                >成份:</span
              >
              <span class="val">{{ detailData.ingredients }}</span>
            </div>
          </div>
          <div class="product-titless">
            <el-tooltip
              effect="dark"
              :content="detailData.title"
              placement="top"
              popper-append-to-body
            >
              <span>{{ detailData.title }}</span>
            </el-tooltip>
          </div>
          <!-- 产品标题 -->
          <div class="product-title">
            <el-tooltip
              effect="dark"
              :content="detailData.content"
              placement="top"
              popper-append-to-body
            >
              <span>{{ detailData.content }}</span>
            </el-tooltip>
          </div>
          <!-- <div class="supply-tags">
          <div class="supply-tag" style="margin-bottom: 120px">面料供应</div>
          <div class="supply-tag">辅料供应</div>
          </div> -->
        </div>
      </div>
      <el-image-viewer
        v-if="imgViewerVisible"
        :url-list="imgViewerList"
        :initial-index="imgViewerIndex"
        @close="closeImgViewer"
      />
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance } from "vue";
import { useStore } from "vuex";
import { ElMessage } from "element-plus";
import MyUpload from "@/components/MyUpload/MyUpload.vue";
const store = useStore();
const { proxy } = getCurrentInstance();
const $api = proxy.$api;
// ==========重点新增这一行，对应模板ref="fileInput"==========
const fileInput = ref(null);

//弹窗相关字段
const dialogVisible = ref(false);
const indexs = ref(0);
const detailData = ref({});
const imgViewerVisible = ref(false);
const imgViewerList = ref([]);
const imgViewerIndex = ref(0);
const sklist = ref([]);
const fabricApplyIds = ref([]);
const mainProductIds = ref([]);
const zylist = ref([]);
const leilist = ref([]);
const userid = ref("");
const xcximg = ref("");
const username = ref("");
const favoriteCount = ref("");
const followCount = ref("");
const enterpriseCode = ref("");
const companyIntro = ref("");
const phone1 = ref("");
const phone2 = ref("");
const phone3 = ref("");
const phone4 = ref("");
const phone5 = ref("");
const address = ref("");
const img = ref("");
const productList = ref([]);
const editDialogVisible = ref(false);
const tempUsername = ref("");
const tempAvatar = ref("");
const selectAvatarFile = ref(null);
// 五组上传图片列表
const coverList = ref([]);
const videoList = ref([]);
const bgImgList = ref([]);
const logoList = ref([]);
const wxList = ref([]);

// 缓存本地新增文件，提交时传给接口
const uploadFileCache = ref({
  cover: null,
  video: null,
  backgroundImg: null,
  logoImg: null,
  weixinImg: null,
});
//弹窗相关js
const tzs = async (id) => {
  const sendata = {
    productId: id,
  };
  const res = await $api.shouye.add(sendata);
  if (res.data.code == "200") {
    detailData.value = res.data.data;
  }
};
const aa = async (id, foll, cpid) => {
  console.log("saass", id);
  const sendata = {
    memberId: id,
    followStatus: foll == 0 ? 1 : 0,
  };
  const res = await $api.shouye.gz(sendata);
  await tzs(cpid);
  console.log(res);
};
const deti = async (id) => {
  sklist.value = [];
  const sendata = {
    productId: id,
  };
  console.log("商品ID：", id);
  const res = await $api.shouye.add(sendata);
  if (res.data.code == "200") {
    detailData.value = res.data.data;
    dialogVisible.value = true;
    sklist.value.push({ url: res.data.data.coverUrl });
    for (let index = 0; index < res.data.data.particularsList.length; index++) {
      sklist.value.push({ url: res.data.data.particularsList[index].url });
    }
    for (let index = 0; index < res.data.data.colorcardList.length; index++) {
      sklist.value.push({ url: res.data.data.colorcardList[index].url });
    }
    console.log(sklist.value, indexs.value, "包含了什么色卡图集");
  }
};
// 关闭弹窗
const closeDialog = () => {
  dialogVisible.value = false;
  detailData.value = {};
  imgViewerVisible.value = false;
  imgViewerList.value = [];
  imgViewerIndex.value = 0;
};
// 打开全屏图片预览
const openImgViewer = (index) => {
  imgViewerList.value = sklist.value.map((item) => getFullImgUrl(item.url));
  imgViewerIndex.value = index;
  imgViewerVisible.value = true;
};
// 关闭图片预览
const closeImgViewer = () => {
  imgViewerVisible.value = false;
};
//下载二维码图片
const getxcx = async () => {
  const imageUrl = `https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=${encodeURIComponent(
    xcximg.value
  )}`;
  try {
    const res = await fetch(imageUrl);
    if (!res.ok) throw new Error("获取二维码失败");
    const blob = await res.blob();
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = "样衣星球小程序二维码.jpg";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
  } catch (err) {
    console.error("下载二维码失败：", err);
    const link = document.createElement("a");
    link.href = imageUrl;
    link.download = "样衣星球小程序二维码.jpg";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};
// 上传选中文件回调
const handleUploadChange = async (list, key) => {
  const fileItem = list[0];
  uploadFileCache.value[key] = fileItem?.file || null;
  const formData = new FormData();
  if (key == "cover") {
    formData.append("videoCoverImg", uploadFileCache.value.cover);
  } else {
    formData.append(key, uploadFileCache.value[key]);
  }
  const res = await $api.My.update(formData);
  console.log(res);
  if (res.data.code == "200") {
    ElMessage.success("修改成功");
  } else {
    ElMessage.error("修改" + res.data.msg);
  }
};
// 删除上传图片
const handleUploadRemove = async (index, key) => {
  let sendata = {};
  // 先清空本地预览列表，界面立刻消失，不用等接口返回
  switch (key) {
    case "cover":
      coverList.value = [];
      sendata = { type: 5 };
      break;
    case "backgroundImg":
      bgImgList.value = [];
      sendata = { type: 1 };
      break;
    case "logoImg":
      logoList.value = [];
      sendata = { type: 2 };
      break;
    case "weixinImg":
      wxList.value = [];
      sendata = { type: 3 };
      break;
    case "video":
      videoList.value = [];
      sendata = { type: 4 };
      break;
  }
  const res = await $api.My.del(sendata);
  if (res.data.code == "200") {
    ElMessage.success("删除成功");
  } else {
    ElMessage.error("删除失败");
  }
};
// 打开弹窗赋值
const openEditDialog = () => {
  editDialogVisible.value = true;
  tempUsername.value = username.value;
  tempAvatar.value = img.value;
  selectAvatarFile.value = null;
};
// 选择头像文件
const handleAvatarChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;
  tempAvatar.value = URL.createObjectURL(file);
  selectAvatarFile.value = file;
};
// 弹窗保存
const submitUserInfo = async () => {
  if (!tempUsername.value.trim()) {
    return ElMessage.warning("昵称不能为空");
  }
  try {
    // 1. 有新头像先单独上传头像
    if (selectAvatarFile.value) {
      await uparls();
    }
    const sendata = {
      nickName: tempUsername.value.trim(),
    };
    const res = await $api.My.updates(sendata);
    if (res.data.code === "200") {
      ElMessage.success("修改成功");
      // ✅ 昵称更新到Vuex，不用拉全量接口
      if (store.state.frontUserInfo.belongId == store.state.frontUserInfo.id) {
        const oldInfo = store.state.frontUserInfo;
        await store.dispatch("setFrontUserInfo", {
          ...oldInfo,
          nickName: tempUsername.value.trim(),
        });
      } else {
        const oldInfo = store.state.frontUserInfo;
        await store.dispatch("setFrontUserInfo", {
          ...oldInfo,
          belongNickName: tempUsername.value.trim(),
        });
      }
      // 同步更新当前页面本地的username
      username.value = tempUsername.value.trim();
    } else {
      ElMessage.error(res.data.msg || "修改失败");
      return;
    }
    editDialogVisible.value = false;
  } catch (err) {
    console.error("修改用户信息异常：", err);
    ElMessage.error("操作失败，请稍后重试");
  }
};
// 全局保存简介/联系方式+五图文件
const saveAll = async (isOnlyNick = false) => {
  const formData = new FormData();
  formData.append("profile", companyIntro.value);
  formData.append("phone1", phone1.value);
  formData.append("phone2", phone2.value);
  formData.append("phone3", phone3.value);
  formData.append("phone4", phone4.value);
  formData.append("phone5", phone5.value);
  formData.append("address", address.value);
  if (mainProductIds.value.length > 0) {
    for (let index = 0; index < mainProductIds.value.length; index++) {
      formData.append(`mainProductIds[${index}]`, mainProductIds.value[index]);
    }
  } else {
    formData.append(`mainProductIds`, mainProductIds.value.length);
  }
  if (fabricApplyIds.value.length > 0) {
    for (let index = 0; index < fabricApplyIds.value.length; index++) {
      formData.append(`fabricApplyIds[${index}]`, fabricApplyIds.value[index]);
    }
  } else {
    formData.append(`fabricApplyIds`, fabricApplyIds.value.length);
  }
  const res = await $api.My.update(formData);
  console.log(res);
  if (res.data.code == "200") {
    ElMessage.success("修改成功");
    await user();
  } else {
    ElMessage.error("修改" + res.data.msg);
  }
  if (!isOnlyNick) {
    ElMessage.success("保存成功");
    await user();
    // 保存成功清空临时文件缓存
    Object.keys(uploadFileCache.value).forEach(
      (k) => (uploadFileCache.value[k] = null)
    );
  }
};
//修改面料适用和主营产品的状态
const ztstatus = (item, names) => {
  console.log(item, names);
  item.status = item.status == 1 ? 0 : 1;
  if (names === "面料") {
    fabricApplyIds.value = leilist.value
      .filter((ele) => ele.status === 1)
      .map((ele) => ele.id);
  } else {
    mainProductIds.value = zylist.value
      .filter((ele) => ele.status === 1)
      .map((ele) => ele.id);
  }
  console.log("主营产品选中id数组：", mainProductIds.value);
  console.log("面料适用选中id数组：", fabricApplyIds.value);
};
// 上传头像接口
const uparls = async () => {
  const formData = new FormData();
  formData.append("avatar", selectAvatarFile.value);
  const res = await $api.My.uparl(formData);
  console.log(res);
  if (res.data.code === "200") {
    ElMessage.success("头像上传成功");
    img.value = getFullImgUrl(res.data.data);
    await store.dispatch("updateFrontAvatar", res.data.data);
  }
};
const getFullImgUrl = (url) => {
  if (!url) return "";
  if (/^https?:\/\//.test(url)) {
    return url;
  }
  return `https://${url}`;
};
// 获取用户信息回填图片（页面初始化时后端返回url赋值预览列表）
const user = async (aa) => {
  const sendata = userid.value;
  try {
    const res = await $api.My.get(sendata);
    if (res.data.code == "200") {
      const data = res.data.data;
      if (aa == "aa") {
        console.log(data.avatarUrl, "最新头像");
        await store.dispatch("updateFrontUserInfoPartial", {
          avatarUrl: data.avatarUrl,
        });
        console.log(
          store.getters.frontUserInfo.avatarUrl,
          "我执行了vuex头像更换了吗"
        );
      }
      // 原有字段赋值
      img.value = getFullImgUrl(data.avatarUrl) || "";
      username.value = data.nickName || "未设置昵称";
      followCount.value = data.followCount || 0;
      companyIntro.value = data.profile || "";
      favoriteCount.value = data.favoriteCount;
      enterpriseCode.value = data.bindCode || "";
      phone1.value = data.phone1 || "";
      phone2.value = data.phone2 || "";
      phone3.value = data.phone3 || "";
      phone4.value = data.phone4 || "";
      phone5.value = data.phone5 || "";
      address.value = data.address || "";
      xcximg.value = data.storeQrcode || "";
      leilist.value = data.fabricApplyList || [];
      zylist.value = data.mainProductList || [];
      fabricApplyIds.value =
        data?.fabricApplyList
          .filter((item) => item.status == 1)
          .map((item) => item.id) || [];
      mainProductIds.value =
        data?.mainProductList
          .filter((item) => item.status == 1)
          .map((item) => item.id) || [];
      // 封面后端字段：videoCoverUrl
      if (data.videoCoverUrl) {
        coverList.value = [
          {
            url: getFullImgUrl(data.videoCoverUrl),
            id: data.id + "_cover",
          },
        ];
      }
      if (data.videoUrl) {
        videoList.value = [
          {
            url: getFullImgUrl(data.videoUrl),
            id: data.id + "_video",
            type: "video",
          },
        ];
      }
      if (data.backgroundUrl) {
        bgImgList.value = [
          {
            url: getFullImgUrl(data.backgroundUrl),
            id: data.id + "_bg",
          },
        ];
      }
      if (data.logoUrl) {
        logoList.value = [
          { url: getFullImgUrl(data.logoUrl), id: data.id + "_logo" },
        ];
      }
      if (data.weixinUrl) {
        wxList.value = [
          { url: getFullImgUrl(data.weixinUrl), id: data.id + "_wx" },
        ];
      }
    }
  } catch (error) {
    console.error("获取用户信息失败：", error);
    img.value = "";
  }
};
// 获取产品
const userpro = async () => {
  const sendata = userid.value;
  try {
    const res = await $api.My.getpro(sendata);
    if (res.data.code == "200") {
      productList.value = res.data.data.list.map((item) => ({
        ...item,
        coverUrl: getFullImgUrl(item.coverUrl),
      }));
    }
  } catch (error) {
    console.error("获取产品失败：", error);
    productList.value = [];
  }
};
const handleProductImgError = (e) => {
  e.target.src = "";
};
onMounted(async () => {
  console.log(store.state.frontUserInfo, "总帐号id为空？");
  userid.value = store.state.frontUserInfo.belongId;
  console.log(userid.value, "是不是总账号id");
  await user();
  await userpro();
});
</script>

<style scoped lang="less">
:deep(.actives) {
  background-color: #ffae00 !important;
  color: #333;
}
:deep(.custom-btn) {
  background-color: #fff;
  border-color: #ffae00;
  color: #333;
}
.company-profile-wrapper {
  background-color: #fff;
  padding: 20px;
  min-height: 100vh;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
}
.bott {
  position: absolute;
  top: 0;
  width: 48px;
  height: 28px;
  right: 0;
}
.botts {
  width: 60px;
  height: 36px;
}
.spann {
  font-size: 12px;
  text-align: center;
}
/* 顶部用户信息样式 */
.user-info-section {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}
.user-avatar {
  display: flex;
  align-items: center;
  margin-right: 24px;
  gap: 12px;
}
.username {
  font-size: 18px;
  font-weight: 500;
}
.user-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
}
.stat-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
}
.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}
.dot.red {
  background-color: #e53e3e;
}
.label {
  color: #333;
}
.value {
  color: #666;
}
/* 表单和产品样式 */
.form-section,
.product-section {
  background: #fff;
  position: relative;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
  width: 90%;
}
.form-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
}
.section-label {
  font-size: 18px;
  color: #333;
  min-width: 92px;
  padding-top: 8px;
}
.form-input {
  flex: 1;
}
/* 上传区域 横向一排自动换行 */
.upload-wrap {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 48px;
}
.upload-title {
  margin: 0 0 8px;
  font-size: 16px;
  text-align: center;
}
.tip {
  color: #fd6f5b;
  font-size: 13px;
  margin-left: 6px;
}
/* 产品 */
.product-list {
  display: flex;
  flex-wrap: wrap;
  gap: 63px;
  margin-top: 29px;
}
.product-item {
  width: 191px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  height: 294px;
  cursor: pointer;
  border-radius: 8px;
  padding: 10px;
  text-align: center;
  overflow: hidden;
}
.product-img-wrapper {
  height: 77%;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  padding: 10px;
  margin-bottom: 8px;
}
.product-img {
  width: 100%;
  height: auto;
  border-radius: 4px;
}
.product-desc {
  height: 23%;
  overflow: hidden;
  font-size: 12px;
  color: #333;
  line-height: 1.4;

  .pd-name,
  .pd-spec {
    margin: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .pd-name {
    margin-bottom: 5px;
  }
}

.avatar-box {
  display: flex;
  align-items: center;
}
.click-avatar {
  cursor: pointer;
}
.dialog-footer-btn {
  text-align: right;
}
/* 响应式布局 */
@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
  }
  .section-label {
    padding-top: 0;
  }
  .product-list {
    justify-content: center;
  }
  .product-item {
    width: 45%;
  }
}
//弹窗样式
:deep(.product-detail-dialog) {
  .el-dialog__body {
    padding: 0 !important;
  }
  .el-carousel__container {
    padding: 0 !important;
  }
  .el-carousel__indicators--outside {
    padding-bottom: 20px;
  }
}
:deep(.el-image-viewer__close) {
  right: 150px !important;
}
.dialog-container {
  display: flex;
  width: 100%;
  height: 80vh;
  overflow: hidden;
  .dialog-left {
    overflow: hidden;
    width: 57%;
    background: #ffffff;
    .img-wrap {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      .el-carousel {
        flex: 1;
        width: 100%;
        padding: 0;
      }
      .empty-img {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #999;
        font-size: 16px;
      }
    }
  }
  .dialog-right {
    width: 43%;
    padding: 30px;
    overflow-y: auto;
    padding-top: 0;
    box-sizing: border-box;
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-thumb {
      background: #ddd;
      border-radius: 2px;
    }
    .author-header {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 30px;
      .avatar {
        flex-shrink: 0;
      }
      .author-name {
        font-size: 18px;
        font-weight: 500;
        flex: 1;
      }
      .follow-btn {
        background: #c1272d;
        border: none;
        padding: 6px 18px;
        color: #fff;
      }
    }
    .info-block {
      margin-bottom: 24px;
      .block-title {
        font-size: 16px;
        color: #333;
        font-weight: 700;
        margin-bottom: 16px;
        font-family: "Source Han Sans SC", "PingFang SC", "Microsoft YaHei",
          sans-serif;
      }
      .info-row {
        font-family: "Source Han Sans SC", "PingFang SC", "Microsoft YaHei";
        margin-bottom: 12px;
        font-size: 13px;
        font-weight: 300; /* Light细体 */
        .label {
          color: #333;
          font-family: "Source Han Sans SC", "PingFang SC", "Microsoft YaHei";
          font-size: 13px;
          font-weight: 300; /* Light细体 */
          text-align: left;
          display: inline-block;
        }
        .val {
          color: #666;
        }
        &.two-col {
          display: flex;
          gap: 40px;
          .col {
            flex: 1;
          }
        }
      }
    }
    .product-title {
      font-size: 16px;
      font-family: "Source Han Sans SC", "PingFang SC", "Microsoft YaHei";
      line-height: 1.5;
      margin-bottom: 16px;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      line-clamp: 4;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .product-titless {
      font-size: 16px;
      font-family: "Source Han Sans SC", "PingFang SC", "Microsoft YaHei";
      line-height: 1.5;
      margin-bottom: 16px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .supply-tags {
      display: flex;
      flex-direction: column;
      gap: 8px;
      margin-bottom: 24px;
      .supply-tag {
        background: #fff9cc;
        font-family: "Source Han Sans SC", "PingFang SC", "Microsoft YaHei";
        font-weight: 300; /* Light细体 */
        padding: 8px 12px;
        font-size: 16px;
        color: #333;
      }
    }
    .detail-content {
      line-height: 1.8;
      font-size: 15px;
      color: #444;
      h2 {
        margin: 16px 0 8px;
      }
      strong {
        color: #000;
      }
    }
  }
}
// 弹窗移动端适配
@media (max-width: 768px) {
  :deep(.product-detail-dialog) {
    width: 98% !important;
  }
  .dialog-container {
    flex-direction: column !important;
    height: auto !important;
    .dialog-left,
    .dialog-right {
      width: 100% !important;
    }
    .dialog-left {
      height: 50vh;
    }
    .dialog-right {
      height: auto;
      max-height: 60vh;
    }
  }
}
</style>
